'use client'

import { type NextPage } from 'next'
import Link from 'next/link'
import { BotHelperRedirectModal } from '@features/bot-helper-redirect'
import { faUserVneck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type User } from '@models/User'
import { Container } from '@tpl/Container'
import EvirmaLogo from '@tpl/layout-root/logo/EvirmaLogo'

import { useAppStore } from '@/entities/app-store'
import AccountUserMenu from '@/shared/layout/header/AccountUserMenu'

const Header: NextPage = () => {
  const appStore = useAppStore()
  if (!appStore) {
    return null
  }

  const user = appStore?.appState?.user || ({} as User)
  return (
    <>
      <BotHelperRedirectModal />
      <Container>
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <EvirmaLogo signStyle="blue" />
          </div>

          <div className="flex items-center">
            {user?.id ? (
              <AccountUserMenu />
            ) : (
              <Link
                href="/auth/login"
                className="flex items-center whitespace-nowrap bg-white border-blue-500 text-blue-500 border hover:bg-blue-500 hover:text-white text-md font-normal py-1 px-4 min-w-[110px] rounded"
              >
                <FontAwesomeIcon icon={faUserVneck} className="w-4 h-4 mr-2" />
                Войти
              </Link>
            )}
          </div>
        </div>
      </Container>
    </>
  )
}

export default Header
